import React from 'react'

type ArrowIconProps = {
  className?: string
  isActive?: boolean
}

const ArrowIcon: React.FC<ArrowIconProps> = ({
  className,
  isActive = false
}) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M1.70703 3.54293L1.35348 3.89648C1.15822 4.09175 1.15822 4.40833 1.35348 4.60359L5.24257 8.49268C5.63309 8.8832 6.26625 8.8832 6.65678 8.49268L10.5459 4.60359C10.7411 4.40833 10.7411 4.09175 10.5459 3.89648L10.1923 3.54293C9.99705 3.34767 9.68047 3.34767 9.48521 3.54293L5.94967 7.07846L2.41414 3.54293C2.21888 3.34767 1.90229 3.34767 1.70703 3.54293Z"
      fill={isActive ? '#0070F4' : '#646A73'}
    />
  </svg>
)

export default ArrowIcon
